import useTranslation from 'next-translate/useTranslation';

// Components
import H2 from '@/components/base/Headings/H2';
import LayoutLogged from '@/components/layouts/LayoutLogged';
import HeaderGroupAnalytics from '@/components/layouts/wrappers/LayoutAnalytics/HeaderAnalytics/HeaderGroupAnalytics';

const HeaderTitleAnalytics = ({ title, isGroup }) => {
    const { t } = useTranslation();
    return (
        <LayoutLogged.Header
            className="!mb-0 flex flex-wrap items-center justify-between gap-3 md:!mb-5"
            aria-label="Progress">
            <H2 className="flex-1">{t(title)}</H2>
            {isGroup ? <HeaderGroupAnalytics /> : null}
        </LayoutLogged.Header>
    );
};

export default HeaderTitleAnalytics;
